import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import {
  State, getApplicationState
} from 'src/app/state-management';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsGuard  {
  constructor(private store: Store<State>, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(getApplicationState).pipe(
      first(),
      mergeMap(applicationState => {
        if (applicationState.appSettings) {
          return of(true);
        }
        else {
          if (!route.paramMap.has('_loadingTo') && route?.routeConfig?.path && route.routeConfig.path != 'loading') {
            // route.params['_loadingTo'] = route.routeConfig.path;
            route.params = {
              ...route.params,
              '_loadingTo': route.routeConfig.path
            }
          }
          return of(this.router.createUrlTree(['loading', route.params], { queryParams: route.queryParams }));
        }
      })
    );
  }

}
